import { Row, Col, Button, Input } from "antd";

const { Search } = Input;

function FilterMenu(props) {
  // Filter Menu Variable & Function
  const onSearch = (value) => props.onSearch(value);

  return (
    <>
      {/* Menu Bar */}
      <Row
        gutter={[8, 8]}
        justify={"end"}
        align="center"
        style={{ marginBottom: "8px" }}
      >
        <Col>
          <Search
            placeholder="Search..."
            allowClear
            onSearch={onSearch}
            style={{ width: 200 }}
          />
        </Col>
        <Col>
          <Button type="primary" onClick={() => props.onShowAdd(true)}>
            + Add Client
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default FilterMenu;
